export default {
    TITLE: 'Sword of the Spirit',
    IMAGE_PATH: '/media/custom-pages/hero-daily-vitals9.jpg',
    DEK: 'Knowing God\'s word(Sword of the Spirit) is the key to victory over sin and the enemy! You need to be equipped and this tool will help you do exactly that!',
    LANDING_URL: '/sword-of-the-spirit'
};